export type ApiContext = 'client' | 'auth' | 'system' | 'public'

export type ApiContextConfig = {
  auth: boolean
  clientId: boolean
}

export const API_CONTEXTS: Record<ApiContext, ApiContextConfig> = {
  client: { auth: true, clientId: true },
  auth: { auth: true, clientId: false },
  system: { auth: true, clientId: false },
  public: { auth: false, clientId: false },
}
